
import {applyMiddleware, compose, createStore} from 'redux';
import thunk from 'redux-thunk';
import rootReducers from './reducers';

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducers,
  // eslint-disable-next-line no-underscore-dangle
  composeEnhancer(applyMiddleware(thunk)),
);

export default store;
